import { Typography } from "@mui/material";
import { styled } from "@mui/system";
export const ContinueLoginBox = styled("div")(({ theme }) => ({
    marginTop: "-65px",
}));
export const ContinueLoginImage = styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    alignItem: "center",
}));
export const PasswordMessage = styled(Typography)(({ theme }) => ({
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "24px",
    textAlign: "center",
    color: "#000000",
}));
export const PasswordSuccessMessage = styled(Typography)(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    textAlign: "center",
    color: "#8E95AA",
}));
